import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to fetch employees and contacts/leads for use in form dropdowns.
 * Returns { employees, contacts, loading } where each is an array of entity objects.
 */
export function useEntityOptions() {
  const [employees, setEmployees] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [empRes, leadsRes] = await Promise.all([
          axios.get(`${API}/api/operations/employees`).catch(() => ({ data: [] })),
          axios.get(`${API}/api/leads`).catch(() => ({ data: [] })),
        ]);
        const emps = (empRes.data || []).map(e => ({
          label: `${e.first_name} ${e.last_name}`.trim(),
          value: `${e.first_name} ${e.last_name}`.trim(),
          email: e.email || '',
          department: e.department || '',
          phone: e.phone || '',
          id: e.id,
        }));
        const leads = (Array.isArray(leadsRes.data) ? leadsRes.data : []).map(l => ({
          label: `${l.first_name || ''} ${l.last_name || ''}`.trim() || l.email || 'Unknown',
          value: `${l.first_name || ''} ${l.last_name || ''}`.trim() || l.email || '',
          email: l.email || '',
          company: l.company || '',
          phone: l.phone || '',
          job_title: l.job_title || '',
          address: l.address || '',
          id: l.id,
        }));
        setEmployees(emps);
        setContacts(leads);
      } catch (err) {
        console.error('useEntityOptions fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, []);

  return { employees, contacts, loading };
}
